<template>
  <div class="withdraw">
    <div class="money">
      <div class="title">{{$t(langKey+'.title')}}</div>
      <div class="num">
        <i v-if="!isAbroad">¥</i>
        <i v-if="isAbroad">$</i>
        <v-input class="v-input" type="number" :placeholder="$t(langKey+'.placeholder')" v-model="balance" @blur="onBalanceBlur"></v-input>
      </div>
      <div class="max">
        {{$t(langKey+'.desc1')}}
        <span>
          <template v-if="!isAbroad">¥</template>
          <template v-if="isAbroad">$</template>{{totalBalance}}</span><a @click="extractAll">{{$t(langKey+'.desc2')}}</a>
      </div>
    </div>
    <div class="account">
      <div class="left">{{$t(langKey+'.item1')}}</div>
      <div class="right"><span>{{this.account}}</span> <img v-if="!isAbroad" :src="require('image/icon/alipay.png')"><img :src="require('image/icon/paypal.png')" v-else></div>
    </div>
    <div class="btn-submit">
      <a v-if="pass" @click="_sendCode" class="active">{{$t(langKey+'.button')}}</a>
      <a v-if="!pass">{{$t(langKey+'.button')}}</a>
    </div>
    <captcha v-model="captcha" ref="captcha" :account="contact" :countdown="captchaCountdown" @resend="resendCode"></captcha>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTitle } from 'components/mixin/title'
import { mapGetters } from 'vuex'
import vInput from 'components/input'
import { getPayAccount, getRewards, cashOut } from 'api/me'
import { MessageBox } from 'mint-ui'
import Captcha from 'components/captcha'
import { sendCode2 } from 'api/equipment'
export default {
  data() {
    return {
      langKey: this.$route.name,
      account: '',
      // 可提现金额
      totalBalance: 0,
      // 提现金额
      balance: null,
      // 验证码
      captcha: '',
      captchaCountdown: 60,
      countdownTimer: null,
      pass: false
    }
  },
  computed: {
    ...mapGetters(['lang', 'isAbroad', 'userInfo']),
    contact() {
      return this.isAbroad ? this.userInfo.email : this.userInfo.mobile
    }
  },
  mixins: [setTitle],
  created() {
    // 有联系方式才发送请求
    if (this.userInfo.mobile || this.userInfo.email) {
      this._getRewards()
      this._getPayAccount()
    }
  },
  methods: {
    _getPayAccount() {
      this.$loading.open()
      getPayAccount(this.contact).then(res => {
        let data = res.data
        this.account = data.pay_account
        this.$loading.close()
      }).catch(err => {
        console.log(err)
        MessageBox.alert(err.msg)
        this.$loading.close()
      })
    },
    _getRewards() {
      this.$loading.open()
      getRewards(this.contact).then(res => {
        console.log(res)
        this.totalBalance = res.data.balance
        this.$loading.close()
      }).catch(err => {
        console.error(err)
        MessageBox.alert(err.msg)
        this.$loading.close()
      })
    },
    // 发送验证码
    _sendCode() {
      this.captchaCountdown = 60
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
      this.$loading.open()
      sendCode2(this.contact).then(res => {
        // 显示验证码输入框
        this.$refs.captcha.open()
        // 成功的提示信息
        this.$toast(this.$t('Captcha.msg1'))
        // 关闭loading
        this.$loading.close()
        // 倒计时
        this.countdownTimer = setInterval(() => {
          this.captchaCountdown--
          if (this.captchaCountdown === 0) {
            this.captchaCountdown = 0
            clearInterval(this.countdownTimer)
            this.countdownTimer = null
          }
        }, 1000)
      }).catch(err => {
        this.$loading.close()
        console.log(err)
        this.$toast(err.msg)
        this.captchaCountdown = 0
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      })
    },
    resendCode() {
      this._sendCode()
    },
    checkForm() {
      let balance = parseFloat(this.balance)
      if (isNaN(balance)) {
        this.pass = false
      } else if (balance < 0.1) {
        this.pass = false
        return '-1'
      } else if (balance > this.totalBalance) {
        this.pass = false
      } else {
        this.pass = true
      }
    },
    extractAll() {
      if (!this.totalBalance) {
        this.$toast(this.$t(this.langKey + '.errorMsg3'))
        return
      }
      this.balance = this.totalBalance + ''
    },
    _submit() {
      let data = {
        amount: this.balance,
        contact: this.contact,
        pay_account: this.account,
        verifycode: this.captcha
      }
      cashOut(data).then(res => {
        console.log(res)
        MessageBox({
          title: this.$t(this.langKey + '.msg2'),
          message: this.$t(this.langKey + '.msg'),
          showCancelButton: false
        }).then(() => {
          this.$router.push('./withdraw-status')
        })
      }).catch(err => {
        console.log(err)
        MessageBox.alert(err.msg)
      })
    },
    onBalanceBlur() {
      if (this.checkForm() === '-1') {
        this.$toast('金额必须大于0.1')
      }
    }
  },
  components: {
    vInput,
    Captcha
  },
  watch: {
    userInfo() {
      this._getRewards()
      this._getPayAccount()
    },
    balance() {
      this.checkForm()
    },
    captcha(nv) {
      if (nv.length === 4) {
        this._submit()
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.countdownTimer)
    this.countdownTimer = null
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .withdraw{
    min-height: 100vh;
    background: #F1F1F1;
    color: #333;
    >.money{
      padding: size(32);
      background-color: #fff;
      >.title{
        font-size: size(30);
        line-height: 1;
        font-weight: 600;
      }
      >.num{
        @include flex();
        width: 100%;
        margin-top: size(32);
        @include border('bottom');
        padding-bottom: size(6);
        i{
          font-style: normal;
          font-size: size(26);
          width: size(30);
          font-weight: 600;
          position: relative;
          bottom: -3px;
        }
        .v-input{
          width: calc(100% - #{size(30)});
          /deep/ input{
            color: #D9251D;
            font-size: size(56);
            height: size(84);
            line-height: size(84);
            background-color: transparent;
            &::placeholder{
              font-size: size(28);
            }
          }
        }
      }
      .max{
        font-size: size(26);
        color: #999;
        margin-top: size(20);
        span{
          color: #333;
          display: inline-block;
          margin-left: size(10);
        }
        a{
          display: inline-block;
          margin-left: size(10);
          color: #1889FC;
        }
      }
    }
    >.account{
      margin-bottom: size(60);
      height: size(112);
      background-color: #fff;
      width: 100%;
      padding: 0 size(32);
      margin-top: size(20);
      @include flex();
      justify-content: space-between;
      font-size: size(30);
      .left{
        font-weight: 600;
      }
      .right{
        color: #999;
        span{
          display: inline-block;
          position: relative;
          top: -6px;
        }
        img{
          width: size(58);
          height: size(58);
          vertical-align: bottom;
        }
      }
    }
    .btn-submit{
      a{
        background-color: #E58B86;
        &.active{
          background-color: #D9251D;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/me/withdraw.vue